import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-correo-cliente-layout',
  templateUrl: './correo-cliente-layout.component.html',
  styleUrls: ['./correo-cliente-layout.component.css']
})
export class CorreoClienteLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
